import React from "react";

function LoaderAnimation ({version = "",type = 'spinner'}) {
    return (
        <>
            <div className={`loadingData${version} col-12 justify-content-center`}>
                <div className={type}></div>
            </div>
        </>
    )}

export default LoaderAnimation;